import Vue from 'vue'
/**
 * CRUD operations for Coach InfoText component
 */
export default {

  getAthleteInfoText (cb) {
    Vue.http.get(Vue.helper.apiUrl() + '/users/athlete/info_text').then(resp => cb(resp.body))
  },
  getCoachInfoText (cb) {
    Vue.http.get(Vue.helper.apiUrl() + '/users/coach/info_text').then(resp => cb(resp.body))
  },
  getCoachAthleteMapping (cb) {
    Vue.http.get(Vue.helper.apiUrl() + '/users/mapping/coach_athlete').then(resp => { cb(resp.body) })
  },
  getDirectorate (cb) {
    Vue.http.get(Vue.helper.apiUrl() + '/users/mapping/directorate').then(resp => { cb(resp.body) })
  },
  getTrophyList (cb) {
    Vue.http.get(Vue.helper.apiUrl() + '/users/athlete/trophy').then(resp => cb(resp.body))
  },

}
